/* Reigning Wet — likes + the notification bell, sitewide.
 *
 * window.ReigningWet.social.likes
 *   .load(trackIds)  -> Promise<{ counts: {id: n}, mine: {id: true} }>
 *   .toggle(trackId) -> Promise<boolean liked>   (asks to sign in first if needed)
 *   .ready           -> false until we know the track_likes table exists
 * Pages (homepage cr8rs + The Current, profiles) call these and listen for
 * 'reigningwet:likes-ready' to show their heart buttons.
 *
 * The bell (snippets/rw-notify-bell.liquid) sits beside the account button:
 * a badge with unread follows/likes, a panel listing them; opening the panel
 * marks them read. Rows come from the notifications table, written only by
 * database triggers (see supabase-migrations/2026-10-17_likes-and-notifications.sql).
 * Before that migration runs, the bell and hearts simply stay hidden.
 */
(function () {
  'use strict';
  var RW = window.ReigningWet = window.ReigningWet || {};
  var social = RW.social = RW.social || {};
  function sb() { return RW.supabase; }
  function me() { var p = RW.getProfile && RW.getProfile(); return p && p.id ? p : null; }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function profileUrl(u) { return RW.getProfileUrl ? RW.getProfileUrl(u) : '/pages/profile?u=' + encodeURIComponent(u); }
  function ago(iso) {
    var m = (Date.now() - new Date(iso).getTime()) / 60000;
    if (!(m >= 0)) return ''; if (m < 1) return 'now'; if (m < 60) return Math.floor(m) + 'm'; if (m < 1440) return Math.floor(m / 60) + 'h';
    if (m < 10080) return Math.floor(m / 1440) + 'd'; return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  // ------------------------------------------------------------------ likes
  var likes = social.likes = { ready: false };
  likes.load = function (ids) {
    var s = sb(), out = { counts: {}, mine: {} };
    ids = (ids || []).filter(Boolean);
    if (!s || !ids.length) return Promise.resolve(out);
    return s.from('track_likes').select('track_id, profile_id').in('track_id', ids).limit(5000).then(function (r) {
      if (r.error) return out;
      var m = me();
      (r.data || []).forEach(function (x) {
        out.counts[x.track_id] = (out.counts[x.track_id] || 0) + 1;
        if (m && x.profile_id === m.id) out.mine[x.track_id] = true;
      });
      return out;
    });
  };
  likes.toggle = function (trackId, likedNow) {
    var s = sb();
    if (!s) return Promise.reject(new Error('offline'));
    if (!me()) {
      return new Promise(function (res, rej) {
        if (!RW.requireAuth) return rej(new Error('signed out'));
        RW.requireAuth(function () { setTimeout(function () { likes.toggle(trackId).then(res, rej); }, 400); });
      });
    }
    var m = me();
    var go = likedNow === undefined
      ? s.from('track_likes').select('track_id').eq('profile_id', m.id).eq('track_id', trackId).maybeSingle().then(function (r) { return !!(r && r.data); })
      : Promise.resolve(likedNow);
    return go.then(function (was) {
      return (was
        ? s.from('track_likes').delete().eq('profile_id', m.id).eq('track_id', trackId)
        : s.from('track_likes').insert({ profile_id: m.id, track_id: trackId })
      ).then(function (r) { if (r.error && r.error.code !== '23505') throw r.error; return !was; });
    });
  };
  // the heart, so every page draws it the same way
  likes.heart = function (on) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" width="16" height="16"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" fill="' + (on ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  };
  function probe() {
    var s = sb(); if (!s) return;
    s.from('track_likes').select('track_id', { count: 'exact', head: true }).limit(1).then(function (r) {
      likes.ready = !r.error;
      if (likes.ready) document.dispatchEvent(new CustomEvent('reigningwet:likes-ready'));
    });
  }

  // ------------------------------------------------------------------ bell
  var B = { items: [], unread: 0, ok: false, open: false, timer: null, people: {} };
  function els() {
    return { wrap: document.getElementById('rw-bell'), btn: document.getElementById('rw-bell-btn'), badge: document.getElementById('rw-bell-badge'), panel: document.getElementById('rw-bell-panel') };
  }
  function drawBadge() {
    var e = els(); if (!e.wrap) return;
    e.wrap.hidden = !(B.ok && me());
    e.badge.hidden = !B.unread;
    e.badge.textContent = B.unread > 9 ? '9+' : String(B.unread);
    e.btn.setAttribute('aria-label', B.unread ? 'Notifications, ' + B.unread + ' new' : 'Notifications');
  }
  function face(p) {
    var name = (p && (p.display_name || p.username)) || '?';
    var letters = (name.split(/[\s._-]+/).filter(Boolean).slice(0, 2).map(function (x) { return x.charAt(0); }).join('') || '?').toUpperCase();
    return '<span class="rw-bell-face"><span>' + esc(letters) + '</span>' + (p && /^https:\/\//i.test(p.avatar_url || '') ? '<img src="' + esc(p.avatar_url) + '" alt="" loading="lazy" onerror="this.remove()">' : '') + '</span>';
  }
  function drawPanel() {
    var e = els(); if (!e.panel) return;
    var m = me();
    var rows = B.items.map(function (n) {
      var a = B.people[n.actor_id], who = a ? (a.display_name || a.username) : 'Someone';
      var text = n.kind === 'follow' ? '<b>' + esc(who) + '</b> started following you'
        : n.kind === 'level' ? 'You leveled up to <i>' + esc(n.note || 'a new level') + '</i>'
        : n.kind === 'badge' ? 'You earned the <i>' + esc(n.note || 'new') + '</i> badge'
        : '<b>' + esc(who) + '</b> liked <i>' + esc(n.track_name || 'your track') + '</i>';
      var href = n.kind === 'follow' && a ? profileUrl(a.username) : (m ? profileUrl(m.username) : '#');
      if (n.kind === 'level' || n.kind === 'badge') a = { display_name: n.kind === 'level' ? '↑' : '★' };
      return '<a class="rw-bell-item' + (n.read_at ? '' : ' is-new') + '" href="' + esc(href) + '">' + face(a) +
        '<span class="rw-bell-text">' + text + '</span><span class="rw-bell-time">' + esc(ago(n.created_at)) + '</span></a>';
    }).join('');
    e.panel.innerHTML = '<div class="rw-bell-head"><span>Notifications</span>' + (B.items.length ? '<button type="button" data-bell="clear">Clear all</button>' : '') + '</div>' +
      (rows || '<p class="rw-bell-empty">Nothing yet. When someone follows you or likes one of your tracks, it shows up here.</p>');
  }
  function fetchBell() {
    var s = sb(), m = me();
    if (!s || !m) { B.ok = !!s && B.ok; B.items = []; B.unread = 0; drawBadge(); return Promise.resolve(); }
    return s.from('notifications').select('*').eq('recipient_id', m.id)
      .order('created_at', { ascending: false }).limit(40).then(function (r) {
        if (r.error) { B.ok = false; drawBadge(); return; }   // table not there yet: keep the bell hidden
        B.ok = true; B.items = r.data || [];
        B.unread = B.items.filter(function (n) { return !n.read_at; }).length;
        var need = B.items.map(function (n) { return n.actor_id; }).filter(function (id, i, a) { return a.indexOf(id) === i && !B.people[id]; });
        drawBadge();
        if (!need.length) { if (B.open) drawPanel(); return; }
        return s.from('profiles').select('id, username, display_name, avatar_url').in('id', need).then(function (pr) {
          ((pr && pr.data) || []).forEach(function (p) { B.people[p.id] = p; });
          if (B.open) drawPanel();
        });
      });
  }
  function markRead() {
    var s = sb(), m = me(); if (!s || !m || !B.unread) return;
    var now = new Date().toISOString();
    s.from('notifications').update({ read_at: now }).eq('recipient_id', m.id).is('read_at', null).then(function () {});
    B.unread = 0; drawBadge();
    setTimeout(function () { B.items.forEach(function (n) { if (!n.read_at) n.read_at = now; }); if (B.open) drawPanel(); }, 2500);   // keep the "new" highlight a moment
  }
  function setOpen(on) {
    var e = els(); if (!e.panel) return;
    B.open = on; e.panel.hidden = !on; e.btn.setAttribute('aria-expanded', on);
    if (on) { drawPanel(); fetchBell().then(markRead); }
  }
  function bootBell() {
    var e = els(); if (!e.wrap || e.wrap.dataset.ready) return;
    e.wrap.dataset.ready = '1';
    e.btn.addEventListener('click', function (ev) { ev.stopPropagation(); setOpen(!B.open); });
    e.panel.addEventListener('click', function (ev) {
      ev.stopPropagation();
      if (ev.target.closest('[data-bell="clear"]')) {
        var s = sb(), m = me(); if (!s || !m) return;
        s.from('notifications').delete().eq('recipient_id', m.id).then(function () {});
        B.items = []; B.unread = 0; drawBadge(); drawPanel();
      }
    });
    document.addEventListener('click', function () { if (B.open) setOpen(false); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && B.open) { setOpen(false); e.btn.focus(); } });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) fetchBell(); });
    clearInterval(B.timer); B.timer = setInterval(function () { if (!document.hidden) fetchBell(); }, 60000);
  }

  function start() {
    bootBell(); probe(); fetchBell();
    document.addEventListener('reigningwet:auth-change', function () { B.people = {}; fetchBell(); });
  }
  if (sb()) start(); else document.addEventListener('reigningwet:supabase-ready', start, { once: true });
})();